import type { CashPlanMonth } from "../types";
import { compactCurrency, monthLabel } from "../lib/calculations";

export function CashPlanChart({ plan }: { plan: CashPlanMonth[] }) {
  const width = 760;
  const height = 240;
  const pad = { top: 24, right: 18, bottom: 42, left: 18 };
  const values = plan.map((item) => item.closingCash);
  const min = Math.min(0, ...values);
  const max = Math.max(0, ...values);
  const range = max - min || 1;
  const x = (index: number) =>
    pad.left + (index / Math.max(1, plan.length - 1)) * (width - pad.left - pad.right);
  const y = (value: number) =>
    pad.top + ((max - value) / range) * (height - pad.top - pad.bottom);
  const points = plan.map((item, index) => `${x(index)},${y(item.closingCash)}`).join(" ");
  const zeroY = y(0);

  return (
    <div className="chart-wrap">
      <svg
        className="cash-chart"
        viewBox={`0 0 ${width} ${height}`}
        role="img"
        aria-label="Projected closing unallocated cash over twelve months"
      >
        <line x1={pad.left} x2={width - pad.right} y1={zeroY} y2={zeroY} className="chart-zero" />
        <polyline points={points} className="chart-line" />
        {plan.map((item, index) => (
          <g key={item.month}>
            <circle cx={x(index)} cy={y(item.closingCash)} r="5" className={item.closingCash < 0 ? "chart-dot-negative" : "chart-dot"} />
            {(index === 0 || index === 2 || index === 5 || index === 8 || index === 11) && (
              <text x={x(index)} y={height - 14} textAnchor="middle" className="chart-label">
                {monthLabel(item.month).split(" ")[0]}
              </text>
            )}
          </g>
        ))}
      </svg>
      <div className="chart-summary">
        <span>Lowest balance <strong>{compactCurrency.format(min)}</strong></span>
        <span>Month 12 <strong>{compactCurrency.format(plan.at(-1)?.closingCash || 0)}</strong></span>
      </div>
    </div>
  );
}
